function TopBar() {
  return (
    <div className="hidden sm:block bg-transparent text-gray-200 text-xs sm:text-sm">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 py-2 flex flex-col sm:flex-row items-center justify-between gap-1">
        <p>Looking for fencing experts in Perth? We're just a call away!</p>
        <div className="flex items-center gap-4">
          <a
            href="tel:0431703770"
            className="flex items-center gap-1.5 hover:text-white transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g filter="url(#filter0_d_56_4921)">
                <g clipPath="url(#clip0_56_4921)">
                  <path
                    d="M6.16667 5.33325H9.5L11.1667 9.49992L9.08333 10.7499C9.9758 12.5595 11.4404 14.0241 13.25 14.9166L14.5 12.8333L18.6667 14.4999V17.8333C18.6667 18.2753 18.4911 18.6992 18.1785 19.0118C17.866 19.3243 17.442 19.4999 17 19.4999C13.7494 19.3024 10.6835 17.922 8.38069 15.6192C6.07792 13.3165 4.69754 10.2505 4.5 6.99992C4.5 6.55789 4.67559 6.13397 4.98816 5.82141C5.30072 5.50885 5.72464 5.33325 6.16667 5.33325"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.5 7.83325C14.942 7.83325 15.366 8.00885 15.6785 8.32141C15.9911 8.63397 16.1667 9.05789 16.1667 9.49992"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.5 4.5C15.8261 4.5 17.0979 5.02678 18.0355 5.96447C18.9732 6.90215 19.5 8.17392 19.5 9.5"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d_56_4921"
                  x="-2"
                  y="-2"
                  width="28"
                  height="28"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_56_4921"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_56_4921"
                    result="shape"
                  />
                </filter>
                <clipPath id="clip0_56_4921">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(2 2)"
                  />
                </clipPath>
              </defs>
            </svg>
            0431 703 770
          </a>
          <a
            href="mailto:quote@stagfencing.com.au"
            className="flex items-center gap-1.5 hover:text-white transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="21"
              viewBox="0 0 24 21"
              fill="none"
            >
              <g filter="url(#filter0_d_56_4924)">
                <g clipPath="url(#clip0_56_4924)">
                  <path
                    d="M17.8333 4.5H6.16667C5.24619 4.5 4.5 5.24619 4.5 6.16667V14.5C4.5 15.4205 5.24619 16.1667 6.16667 16.1667H17.8333C18.7538 16.1667 19.5 15.4205 19.5 14.5V6.16667C19.5 5.24619 18.7538 4.5 17.8333 4.5Z"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.5 6.1665L12 11.1665L19.5 6.1665"
                    stroke="white"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <filter
                  id="filter0_d_56_4924"
                  x="-2"
                  y="-3.66675"
                  width="28"
                  height="28"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_56_4924"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_56_4924"
                    result="shape"
                  />
                </filter>
                <clipPath id="clip0_56_4924">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(2 0.333252)"
                  />
                </clipPath>
              </defs>
            </svg>
            quote@stagfencing.com.au
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
